import {
  AlertCircleFillIcon,
  AlertTriangleFillIcon,
  ArcFillIcon,
  ChangeLocation,
  ChartFillIcon,
  ChevronDownFillIcon,
  ChevronLeftFillIcon,
  ChevronRightFillIcon,
  ChevronUpFillIcon,
  ConeFillIcon,
  DocumentationFillIcon,
  EllipsisFillIcon,
  EyeOffFillIcon,
  FacebookFillIcon,
  ForbiddenFillIcon,
  HelpCircleFillIcon,
  HomeFillIcon,
  InboxFillIcon,
  LifeBuoyFillIcon,
  LogOutFillIcon,
  MaximizeFillIcon,
  MaximizeSquareFillIcon,
  MenuFillIcon,
  MessageRoundFillIcon,
  MessageSquareFillIcon,
  MinimizeFillIcon,
  MoveFillIcon,
  PaperClipFillIcon,
  RoadFillIcon,
  RotateCCWFillIcon,
  SearchFillIcon,
  SendFillIcon,
  SettingsFillIcon,
  SunriseFillIcon,
  TrendingUpFillIcon,
  VolumeFillIcon,
  VolumeMuteFillIcon,
  WheelFillIcon,
  ZapFillIcon,
} from '@ornikar/kitt-icons';
import {
  ArrowDownFillIcon,
  ArrowDownRightFillIcon,
  ArrowLeftFillIcon,
  ArrowRightFillIcon,
  ArrowUpFillIcon,
  ArrowUpRightFillIcon,
  BellFillIcon,
  BookmarkFillIcon,
  BroadcastFillIcon,
  CalendarFillIcon,
  CheckCircleFillIcon,
  CheckFillIcon,
  CheckSquareFillIcon,
  ClipboardFillIcon,
  ClockFillIcon,
  CoinsFillIcon,
  CopyFillIcon,
  DownloadFillIcon,
  EyeFillIcon,
  FileTextFillIcon,
  FolderFillIcon,
  GiftFillIcon,
  HashFillIcon,
  HeadphonesFillIcon,
  HeartFillIcon,
  InfoFillIcon,
  ListFillIcon,
  LockFillIcon,
  MapPinFillIcon,
  PauseFillIcon,
  PencilFillIcon,
  PhoneFillIcon,
  PlayFillIcon,
  PlusFillIcon,
  ShoppingCartFillIcon,
  StarFillIcon,
  SunFillIcon,
  ThumbsUpFillIcon,
  TimerFillIcon,
  ToggleRightFillIcon,
  TrashFillIcon,
  UploadFillIcon,
  UserFillIcon,
  UsersFillIcon,
  XCircleFillIcon,
  XFillIcon,
} from '@ornikar/kitt-icons/phosphor';

export const appSetFill = {
  // legacy imports from the time where we were using font awesome
  /** @deprecated This icon use an outdated design file. Update file with icon from the actual set */
  camera: HashFillIcon,
  /** @deprecated use hash icon instead */
  sharp: HashFillIcon,
  /** @deprecated This icon use an outdated design file. Update file with icon from the actual set */
  power: HashFillIcon,
  /** @deprecated use shopping-cart icon instead */
  cart: ShoppingCartFillIcon,
  /** @deprecated This icon use an outdated design file. Update file with icon from the actual set */
  document: HashFillIcon,
  /** @deprecated use search icon instead */
  wen: SearchFillIcon,

  // Current Icons set
  search: SearchFillIcon,
  'alert-circle': AlertCircleFillIcon,
  'alert-triangle': AlertTriangleFillIcon,
  'arrow-down': ArrowDownFillIcon,
  'arrow-left': ArrowLeftFillIcon,
  'arrow-right': ArrowRightFillIcon,
  'arrow-up': ArrowUpFillIcon,
  'arrow-up-right': ArrowUpRightFillIcon,
  'arrow-down-right': ArrowDownRightFillIcon,
  bell: BellFillIcon,
  bookmark: BookmarkFillIcon,
  broadcast: BroadcastFillIcon,
  calendar: CalendarFillIcon,
  chart: ChartFillIcon,
  'change-location': ChangeLocation,
  'check-circle': CheckCircleFillIcon,
  'check-square': CheckSquareFillIcon,
  check: CheckFillIcon,
  'chevron-down': ChevronDownFillIcon,
  'chevron-left': ChevronLeftFillIcon,
  'chevron-right': ChevronRightFillIcon,
  'chevron-up': ChevronUpFillIcon,
  clipboard: ClipboardFillIcon,
  clock: ClockFillIcon,
  cross: XFillIcon,
  cone: ConeFillIcon,
  copy: CopyFillIcon,
  'cross-circle': XCircleFillIcon,
  documentation: DocumentationFillIcon,
  download: DownloadFillIcon,
  ellipsis: EllipsisFillIcon,
  'eye-off': EyeOffFillIcon,
  eye: EyeFillIcon,
  facebook: FacebookFillIcon,
  forbidden: ForbiddenFillIcon,
  'file-text': FileTextFillIcon,
  folder: FolderFillIcon,
  gift: GiftFillIcon,
  hash: HashFillIcon,
  headphones: HeadphonesFillIcon,
  heart: HeartFillIcon,
  'help-circle': HelpCircleFillIcon,
  home: HomeFillIcon,
  inbox: InboxFillIcon,
  info: InfoFillIcon,
  'life-buoy': LifeBuoyFillIcon,
  list: ListFillIcon,
  loader: ArcFillIcon,
  lock: LockFillIcon,
  'log-out': LogOutFillIcon,
  'map-pin': MapPinFillIcon,
  maximize: MaximizeFillIcon,
  'maximize-square': MaximizeSquareFillIcon,
  menu: MenuFillIcon,
  'message-round': MessageRoundFillIcon,
  'message-square': MessageSquareFillIcon,
  minimize: MinimizeFillIcon,
  move: MoveFillIcon,
  paperclip: PaperClipFillIcon,
  pause: PauseFillIcon,
  pencil: PencilFillIcon,
  phone: PhoneFillIcon,
  play: PlayFillIcon,
  'play-filled': PlayFillIcon,
  plus: PlusFillIcon,
  road: RoadFillIcon,
  'rotate-ccw': RotateCCWFillIcon,
  settings: SettingsFillIcon,
  'shopping-cart': ShoppingCartFillIcon,
  send: SendFillIcon,
  star: StarFillIcon,
  'star-filled': StarFillIcon,
  'thumbs-up': ThumbsUpFillIcon,
  'toggle-right': ToggleRightFillIcon,
  'trending-up': TrendingUpFillIcon,
  upload: UploadFillIcon,
  sun: SunFillIcon,
  sunrise: SunriseFillIcon,
  user: UserFillIcon,
  users: UsersFillIcon,
  volume: VolumeFillIcon,
  /** @deprecated: use volume icon instead  */
  'volume-2': VolumeFillIcon,
  'volume-x': VolumeMuteFillIcon,
  coins: CoinsFillIcon,
  trash: TrashFillIcon,
  timer: TimerFillIcon,
  wheel: WheelFillIcon,
  zap: ZapFillIcon,
  'zap-filled': ZapFillIcon,
};
